export default __webpack_public_path__ + "static/media/ER.296721d3.svg";